var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal modal-filter-details fade",
      attrs: {
        id: "modal-notify-managers",
        role: "dialog",
        "aria-labelledby": "shortlist-modal-label",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h4",
              {
                staticClass: "modal-title",
                attrs: { id: "shortlist-modal-label" },
              },
              [[_vm._v("Notify Managers")]],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c(
                "form",
                {
                  staticClass: "form-horizontal",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("label", { staticClass: "sr-only" }, [
                    _vm._v("Search for managers"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.keywords,
                          expression: "search.keywords",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Manager Name..." },
                      domProps: { value: _vm.search.keywords },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.search, "keywords", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "input-group-btn" },
                      [
                        _c(
                          "ladda-button",
                          {
                            ref: "search",
                            staticClass: "btn btn-dark",
                            attrs: {
                              type: "submit",
                              click: _vm.handleSearchManagersCallback,
                            },
                          },
                          [_vm._v("\n                Search\n              ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _vm.haveNoManagersWithoutExisting && _vm.notSearching
                    ? _c("div", { staticClass: "text-center" }, [
                        _c("h5", [
                          _vm._v(
                            "There are no managers. Try searching to find who you want."
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.haveSearchText
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-default btn-sm",
                                on: { click: _vm.handleClearSearchCallback },
                              },
                              [_vm._v("Clear Search")]
                            )
                          : _vm._e(),
                      ])
                    : _c(
                        "ul",
                        { staticClass: "shortlist-modal-results" },
                        _vm._l(_vm.managerWithoutExisting, function (manager) {
                          return _c(
                            "li",
                            { key: manager.id, staticClass: "row" },
                            [
                              _c("div", { staticClass: "col-xs-9 col-sm-10" }, [
                                _c("div", { staticClass: "details" }, [
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v(_vm._s(manager.name)),
                                    ]),
                                    _vm._v(" - " + _vm._s(manager.company)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-xs-3 col-sm-2" }, [
                                _vm.managerIsAlreadyAdded(manager)
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-lg btn-success",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemoveManagerCallback(
                                              manager
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-fw fa-check",
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-lg btn-default",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAddManagerCallback(
                                              manager
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-fw fa-plus",
                                        }),
                                      ]
                                    ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                ]
              ),
              _vm._v(" "),
              _c(
                "lazy-loading",
                {
                  ref: "lazyLoading",
                  staticClass: "text-center",
                  attrs: {
                    "scroll-target": "#modal-notify-managers .modal-body",
                    "reached-bottom": _vm.getManagersForNextPage,
                  },
                },
                [
                  _c("pickstar-loading", {
                    attrs: { slot: "loading" },
                    slot: "loading",
                  }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "finished" }, slot: "finished" }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-lg btn-primary",
                  attrs: {
                    type: "button",
                    click: _vm.handleNotifyManagersCallback,
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-check" }),
                  _vm._v(" Notify\n        "),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-lg btn-danger pull-left",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("i", { staticClass: "fa fa-close" }), _vm._v(" Cancel")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }